let practice_setup_finish_setup = function( $ ) {

	let $link;

	let _init = function() {
		$link = $( '#finish-practice-setup' );

		if ( $link.length > 0 ) {
			_setup_complete_click();
		}
	};

	let _setup_complete_click = function() {
		$link.on( 'click', ( e ) => {
			e.preventDefault();

			$link.closest( '.container' ).loading();

			if ( $link.attr( 'href' ).startsWith( '#' ) ) {
				_finish_setup();
			} else {
				_finish_setup( $link.attr( 'href' ) )
			}
		} )
	};

	let _finish_setup = function( redirect = '' ) {
		let data = {
			nonce: ScriptData.crate_finish_practice_setup_nonce,
			action: 'crate_finish_practice_setup'
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			console.log( response );

			$link.closest( '.container' ).loaded();

			if ( redirect ) {
				window.location.href = redirect;
			}
		} )
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = practice_setup_finish_setup;